import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type FeatureFlagsService from 'garaje/services/feature-flags';

export default class LocationOverviewCommunicationsThreatDashboardRoute extends Route {
  @service declare router: RouterService;
  @service declare featureFlags: FeatureFlagsService;

  beforeModel(): void {
    // Gated on the threat-dashboard v2 split — the global dashboard is emno-fe
    // (v2) only, matching the flag the per-location embed uses to switch to the
    // migrated app. Falls back to the global message log.
    if (!this.featureFlags.isEnabled('emno-threat-intelligence-web-v2')) {
      void this.router.transitionTo('location-overview.communications.message-log');
    }
  }
}
